import type { AutomationActions } from "@/types/automation";

export const MAX_ALLOWED_ITEMS = 500;

export const bulkCopyItemActions: AutomationActions = {
  id: "monday-runFromList",
  parms: {
    options: "parallel=8,keepReplacementVariables",
    input: [
      {
        action: "copyItem",
        item: "@entry@",
        toBoard: "",
        reference: "copyItem_@entry@",
        outputType: "variables",
      },
    ],
    list: "",
    continue: true,
    action: "runFromList",
    outputType: "variables",
  },
};
